import Container from '@/components/Container'
import { Button } from '@/components/ui/button'
import { TypographyLarge, TypographyMuted } from '@/components/ui/typography'
import { Link } from 'react-router-dom'

const Forbidden = () => {
    return (
        <Container className="mt-[8rem] gap-10 items-center">
            <div className="flex flex-col items-center justify-center">
                <TypographyLarge className="text-[8rem] font-bold text-primary">
                    403
                </TypographyLarge>
                <TypographyMuted className="text-center">
                    Oopss... Parece que você não tem permissão para acessar essa
                    página ou recurso
                </TypographyMuted>
            </div>
            <Button size="lg">
                <Link to="/" replace>
                    Voltar para página inicial
                </Link>
            </Button>
        </Container>
    )
}

export default Forbidden
